import React from "react";
import { Form } from "react-bootstrap";
import styles from "./fields.module.scss";

export const ReadOnlyInput = ({ name, value, ...props }) => {
	return (
		<Form.Control
			readOnly
			name={name}
			value={value}
			className={styles.readOnlyInput}
			{...props}
		/>
	);
};
